<template>
  <button :type="type" class="btn btn-primary checkout-step__button liquid-page-button">
    <span class="liquid-page-button__glow" aria-hidden="true"></span>
    <span class="liquid-page-button__ring" aria-hidden="true"></span>
    <span class="liquid-page-button__inner">
      <span class="liquid-page-button__copy"><slot /></span>
      <span v-if="icon" class="liquid-page-button__icon" aria-hidden="true"><i :class="icon"></i></span>
    </span>
  </button>
</template>
<script>
export default {
  name: 'CheckoutButton',
  props: {
    type: { type: String, default: 'button' },
    icon: { type: String, default: 'fas fa-arrow-right' },
  },
}
</script>
